import DynamicFilterSliders from './DynamicFilterSliders'
import Favorite from '../../../assets/images/Favorite-bg4.png'

export default function FilterDataSlider({checkedFilters , sliderData , onLoadMore,isLoading}) {
    return (
        <>
            <section className="sub_banner_box favorite-section uk-scrollspy-inview"
                style={{ backgroundImage: `url(${Favorite})` }}>
                <div className="container d-flex justify-content-center text-center">
                    <div className="favorite-block sub_banner_text_box uk-scrollspy-inview"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                        <h2 className="mb-2">Craving Something Delicious?</h2>
                        <p>Order from your favorite dishes and get them delivered hot and fresh to your doorstep
                            in no time.</p>
                    </div>
                </div>
            </section>

           <DynamicFilterSliders checkedFilters={checkedFilters} sliderData={sliderData} onLoadMore={onLoadMore} isLoading={isLoading} />

        </>
    )
}
